import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import BrowserDetection from 'react-browser-detection'

import headerPhoneVideo from '@/assets/video/sdk-phone-med.mp4'
import { desktop, mobile } from '@/utils/media-query'

const EdgeVideo = styled.div`
  @media ${desktop.query} {
    position: absolute;
    right: 0;
    top: -35px;
    height: 730px;
    z-index: 1;

    video {
      clip-path: url(#clipping);
      height: 730px;
    }

    svg {
      width: 463px;
      height: 100%;
    }
  }

  @media ${mobile.query} {
    opacity: 0.2;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;

    svg {
      width: 463px;
      height: 100%;
    }

    video {
      height: 80%;
      clip-path: url(#clipping);
    }
  }
`

const DefaultVideo = styled.div`
  @media ${desktop.query} {
    position: absolute;
    right: 0;
    height: 730px;
    z-index: 1;
    transform: translate(-12px, -35px);
    clip-path: polygon(
      13.52% 91.93%,
      13.07% 90.05%,
      13.75% 88.23%,
      14.69% 86.49%,
      15.25% 79.85%,
      0px 61%,
      20.33% 2.96%,
      86.69% 1.96%,
      86.4% 38.29%,
      93.53% 47.96%,
      87.77% 47.72%,
      86.34% 88.9%,
      86.61% 92.73%,
      82.96% 96.63%,
      16.86% 94.49%
    );

    video {
      height: 730px;
    }
  }

  @media ${mobile.query} {
    opacity: 0.2;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    video {
      height: 80%;
      transform: translate(6%, -12%);
    }
  }
`

export const HeaderVideo = () => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  /*
        Edge and IE do not support a full css solution for video clipping so must default to a svg version
    */
  const browserDetectionHandler = {
    edge: () => (
      <EdgeVideo>
        <svg xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="clipping" clipPathUnits="objectBoundingBox">
              <polygon points="0.1352, 0.9193, 0.1307, 0.9005, 0.1375, 0.8823, 0.1469, 0.8649, 0.1525, 0.7985, 0.0, 0.61, 0.2033, 0.0296, 0.8669, 0.0196, 0.864, 0.3829, 0.9353, 0.4796, 0.8777, 0.4772, 0.8634, 0.889, 0.8661, 0.9273, 0.8296, 0.9663, 0.1686, 0.9449" />
            </clipPath>
          </defs>

          <foreignObject width="100%" height="100%" clipPath="url(#clipping)">
            <video autoPlay loop muted playsInline>
              <source src={headerPhoneVideo} type="video/mp4" />
            </video>
          </foreignObject>
        </svg>
      </EdgeVideo>
    ),
    default: () => (
      <DefaultVideo>
        <video autoPlay loop muted playsInline>
          <source src={headerPhoneVideo} type="video/mp4" />
        </video>
      </DefaultVideo>
    ),
  }

  return mounted ? <BrowserDetection>{browserDetectionHandler}</BrowserDetection> : null
}
